import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { billingApi } from '../../api/billing';
import './BankTransferAddonCard.css';

/**
 * BankTransferAddonCard — slim offering toggle for the free bank-transfer
 * feature (post-pivot 2026-05-10). Filename retained for git history.
 *
 * Renders the "Bank Transfer" subsection title row with an iOS-style toggle
 * on the right (matching the "Make School Visible" pattern in Settings.js)
 * plus a hint paragraph below.
 *
 * Honest fee disclosure: when the offering is on, students paying by direct
 * bank transfer skip both the 2.5% platform fee and the ~1.7% + 30c Stripe
 * processing fee.
 */
const BankTransferAddonCard = ({ offeringEnabled, hasBankDetails, onChange }) => {
    const [busy, setBusy] = useState(false);

    const handleToggle = async (e) => {
        const enabled = e.target.checked;
        setBusy(true);
        try {
            await billingApi.setOfferingEnabled(enabled);
            toast.success(enabled ? 'Bank transfer offering enabled.' : 'Bank transfer offering disabled.');
            await onChange?.();
        } catch (err) {
            toast.error(err.message || 'Failed to update offering.');
        } finally {
            setBusy(false);
        }
    };

    const hint = !hasBankDetails
        ? 'Add your bank details below before turning the offering on.'
        : 'When on, new payment emails include your bank details and a unique reference code. Existing emails are not changed.';

    const toggleDisabled = busy || !hasBankDetails;

    return (
        <div className="bank-transfer-addon-card">
            <div className="bank-transfer-addon-card-title-row">
                <h5 className="bank-transfer-addon-card-title">Bank Transfer</h5>
                <label
                    className="dashboard-toggle-ios"
                    title={
                        offeringEnabled
                            ? 'Bank transfer is offered to students in payment emails'
                            : hasBankDetails
                                ? 'Turn on to offer bank transfer to students in payment emails'
                                : 'Add bank details below before turning on'
                    }
                    style={{ cursor: toggleDisabled ? 'not-allowed' : 'pointer', opacity: toggleDisabled ? 0.6 : 1 }}>
                    <input
                        type="checkbox"
                        checked={!!offeringEnabled}
                        onChange={handleToggle}
                        disabled={toggleDisabled}
                    />
                    <span className="toggle-slider"></span>
                    <span className="toggle-label" style={{ marginLeft: 8 }}>
                        Offer to students
                    </span>
                </label>
            </div>
            <p className="bank-transfer-addon-card-toggle-hint">{hint}</p>
        </div>
    );
};

export default BankTransferAddonCard;
